// Position Group Selector Component
// Simple position group selection - coach-specific labels handled in formations

import React from 'react';
import { getPositionGroups, type PositionGroup, type PositionUnitType } from '../../data/positionHierarchy';
import type { Sport } from '../../types';

interface PositionGroupSelectorProps {
  sport: Sport;
  unit: PositionUnitType;
  selectedGroups: string[];
  onGroupToggle: (groupKey: string) => void;
}

export const PositionGroupSelector: React.FC<PositionGroupSelectorProps> = ({
  sport,
  unit,
  selectedGroups,
  onGroupToggle,
}) => {
  const groups = getPositionGroups(sport, unit);

  if (groups.length === 0) {
    return <p className="text-sm text-gray-500">No position groups available</p>;
  }

  return (
    <div className="flex flex-wrap gap-2">
      {groups.map((group) => {
        const isSelected = selectedGroups.includes(group.key);
        return (
          <button
            key={group.key}
            type="button"
            onClick={() => onGroupToggle(group.key)}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              isSelected
                ? 'bg-primary text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300'
            }`}
          >
            {group.key}
          </button>
        );
      })}
    </div>
  );
};

